import React from 'react';
import PropTypes from 'prop-types';
import { HeaderDefault } from '../components/Header';
import { getLargeImage } from '../utils/prismic';

const HeroTitle = ({ input }) => {
  //console.log(input.items);
  const {
    thumbnail,
    video,
    title,
    subtitle,
    description,
    align_text,
    align_image,
    button_label,
    button_link,
  } = input.primary;

  /* MEDIA CHECK */
  const hasVideo = video && video.embed_url;
  const hasImage = thumbnail &&
    thumbnail.url && {
      src: getLargeImage(thumbnail).url,
      width: getLargeImage(thumbnail).width,
      height: getLargeImage(thumbnail).height,
      alt: getLargeImage(thumbnail).alt,
    };
  const mediaType = hasVideo ? 'video' : hasImage ? 'image' : 'none';
  const hasMedia = hasVideo
    ? { type: mediaType, media: video }
    : { type: mediaType, media: hasImage };

  const hasButton = button_label && {
    label: button_label,
    ...button_link,
  };

  /* CONTENT CHECK */
  const hasTitle = title && title.html;
  const hasSubtitle = subtitle && subtitle.html;
  const hasDescription = description && description.html;
  const content = {
    hasContent: !(!hasTitle && !hasSubtitle && !hasDescription),
    title: hasTitle,
    subtitle: hasSubtitle,
    description: hasDescription,
    icons: input.items.length >= 1 ? input.items : null,
    button: hasButton,
  };
  /*
  const data = {
    title: title.html,
    subtitle: subtitle.html,
    description: description.html,
    textAlign: align_text,

    image_align: align_image,

    image_src: getLargeImage(thumbnail).url,
    image_width: getLargeImage(thumbnail).width,
    image_height: getLargeImage(thumbnail).height,
    image_alt: getLargeImage(thumbnail).alt,

    video_src: video.embed_url || video.url,
    video_width: video.width,
    video_height: video.height,

    icons:
      input.items.length >= 1
        ? input.items.map(({ icon }, index) => {
            return {
              icon_src: getTinyImage(icon).url,
              //icon_width: getTinyImage(icon).width,
              //icon_height: getTinyImage(icon).height,
              icon_height: '56',
              icon_alt: getTinyImage(icon).alt,
            };
          })
        : null,
  };
  const dataButton = button_label
    ? {
        label: button_label,
        ...button_link,
      }
    : null;

   */

  return (
    <HeaderDefault
      align_text={align_text.toLowerCase()}
      align_image={align_image.toLowerCase()}
      content={content}
      media={hasMedia}
    />
  );
};

HeroTitle.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroTitle;
